import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface HotjarWindow extends Window {
  hj?: ((...args: any[]) => void) & { q?: any[] };
  _hjSettings?: { hjid: number; hjsv: number };
}

@Injectable({
  providedIn: 'root',
})


export class HotjarService {
  constructor() {}

  loadHotjar(): void {
    const win = window as HotjarWindow; // Type assertion

    if (typeof win !== 'undefined' && !win.hj) {
      (function (h: HotjarWindow, o: Document, t: string, j: string, a?: HTMLElement, r?: HTMLScriptElement) {
        h.hj =
          h.hj ||
          (function (...args: any[]) {
            (h.hj!.q = h.hj!.q || []).push(args);
          } as HotjarWindow['hj']);

        h._hjSettings = { hjid: environment.hotjarId, hjsv: 6 };

        a = o.getElementsByTagName('head')[0] as HTMLElement;
        r = o.createElement('script');
        r.async = true;
        r.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;

        a.appendChild(r);
      })(win, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }
}
